import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 7.51a1.4 1.4 0 0 1-1.189-.666c-.29-.469-.678-.947-1.114-1.294-.436-.346-.839-.5-1.197-.5-.683 0-1.157.241-1.48.614-.34.394-.62 1.067-.62 2.095 0 .497.186 1.118.597 1.848.405.722.982 1.466 1.642 2.186 1.178 1.284 2.525 2.389 3.368 3.034.841-.639 2.184-1.733 3.359-3.012.658-.717 1.233-1.46 1.637-2.183.41-.731.597-1.36.597-1.873 0-1.207-.297-1.844-.595-2.172-.282-.309-.74-.532-1.508-.536-.342-.002-.739.146-1.18.497-.44.35-.833.833-1.126 1.303a1.4 1.4 0 0 1-1.192.659Zm-.9-2.57c.36.372.664.782.903 1.17a7.11 7.11 0 0 1 .906-1.168c.695-.719 1.589-1.296 2.595-1.291C15.604 3.66 17 4.92 17 7.759c0 3.353-4.794 7.186-6.445 8.407a.915.915 0 0 1-1.102-.002C7.803 14.932 3 11.064 3 7.759 3 5.209 4.397 3.65 6.5 3.65c1.016 0 1.909.573 2.6 1.29Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=HeartIcon20.js.map